import { api } from './api'

const LOGIN_ENDPOINT = process.env.VUE_APP_AFFILIATE_LOGIN_ENDPOINT || '/api/affiliate/login'
const SIGNUP_ENDPOINT = process.env.VUE_APP_AFFILIATE_SIGNUP_ENDPOINT || '/api/affiliate/signup'

export const auth = {
  async login(email, password) {
    const { data } = await api.post(LOGIN_ENDPOINT, { email, password })
    if (!data || !data.token) throw new Error('Invalid login response: missing token')
    localStorage.setItem('affiliate_token', data.token)
    localStorage.setItem('affiliate_email', data.user?.email || email)
    if (data.user?.id) localStorage.setItem('affiliate_id', data.user.id)
    return data
  },
  async signup(name, email, password) {
    const { data } = await api.post(SIGNUP_ENDPOINT, { name, email, password })
    if (!data || !data.token) throw new Error('Invalid signup response: missing token')
    localStorage.setItem('affiliate_token', data.token)
    localStorage.setItem('affiliate_email', data.user?.email || email)
    if (data.user?.id) localStorage.setItem('affiliate_id', data.user.id)
    return data
  },
  logout() {
    localStorage.removeItem('affiliate_token')
    localStorage.removeItem('affiliate_email')
  },
  isAuthenticated() {
    return !!localStorage.getItem('affiliate_token')
  }
}
